import jquery from 'jquery';

export function setupVendorGlobals() {
    window.$ = jquery;
    window.jQuery = jquery;

    return true;
}
